// The Simustage logo shown next to the "Simustage" wordmark everywhere it
// appears (app topbar, marketing header/footer, sign-in screen, page
// transitions). Sizing/rounding lives on the shared `.logo` rule in
// style.css so every call site stays consistent.
export function brandMarkHtml() {
  return `<img class="logo" src="/logo.png" alt="Simustage" />`;
}
